/**
 * QLD Courts design has a card with an icon that is displayed on the left side of the card on mobile, top for desktop.
 * An extra option has been added to the card component to allow for this which adds the data-icon-align attribute to the card.
 * This script ensures that the icon is displayed on the left for mobile, top for desktop, by toggling classes.
 */
(function () {
    'use strict';

    function initCardLayout() {
        const cardsWithIcon = document.querySelectorAll('.qld__card.qld__card--icon[data-icon-align="left-mobile-top-desktop"]');
        const leftClass = 'qld__card--icon-left';
        const mediumBreakpoint = 768;

        if (cardsWithIcon.length > 0) {
            function handleCardLayout() {
                const isMobile = window.innerWidth < mediumBreakpoint;
                cardsWithIcon.forEach(card => {
                    card.classList.toggle(leftClass, isMobile);
                });
            }

            handleCardLayout();
            window.addEventListener('resize', handleCardLayout);
        }
    }

    document.addEventListener('DOMContentLoaded', initCardLayout); 
}());